export const userCookies = {
  C_ID: 'c_id',
  CONTACT_UUID: 'contact_uuid',
  CURRENCY_RATE: 'currency_rate',
  NEWSLETTER_SIGNUP: 'newsletter_signup'
};
